import "./App.css";
import React from "react";
import Navbar from "./components/navbar";
import Footer from "./components/footer";

function App() {
	return (
		<React.Fragment>
			<Navbar />
			<Footer />
		</React.Fragment>
	);
}

export default App;
